export default __webpack_public_path__ + "static/media/11_dave_jay.ac0fd9f5.png";